// const BASE_URL = "http://localhost:5000/api/v1";
const BASE_URL = "https://backend.hairsncares.com/api/v1";

// const BASE_URL = "https://apihair.txogavideo.in/api/v1";

// const BASE_URL = "https://v5hqnvqt-5000.inc1.devtunnels.ms/api/v1";
// const BASE_URL = "https://backend.hairsncares.com/api/v1";


export default BASE_URL;
